import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';

const StyledProcessing = styled.div`
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0; margin: auto;
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 80px;
  ${media.phone`
    height: 60px; 
  `}
  justify-content: space-between;
    h4.textHint {
      width: 100%;
      text-align: center;
      font-weight: 300;
      font-size: 18px;
      color: white;
      ${media.phone`
        font-size: 16px;
        margin-top: 18px;
      `}      
    }
    .processing {
    --size: 16px;
    ${media.phone`
      --size: 9px;
    `}
    list-style: none;
    display: flex;
    width: 100%;
    justify-content: space-between;
    height: var(--size);
    @keyframes processingPulse {
      0% { box-shadow: 0 0 0 0 white; }
      70% { box-shadow: 0 0 0 20px white; }
      100% { box-shadow: 0 0 0 0 white; }
    }
    @keyframes processingOp {
      0% { opacity: .5 }
      70% { opacity: 0 }
      100% { opacity: 0}
    }
    li {
      width: var(--size); height: var(--size);
      border-radius: 50%;
      background: white;
      position: relative;
      &:before {
        position: absolute;
        content: '';
        width: var(--size); height: var(--size);
        left: 0; top: 0;
        border-radius: 50%;
        animation: processingPulse 2s infinite, processingOp 2s infinite;
      }
    }
    li:nth-child(1):before {
      animation-delay: 200ms;
    }
    li:nth-child(2):before {
      animation-delay: 400ms;
    }
    li:nth-child(3):before {
      animation-delay: 600ms;
    }
    li:nth-child(4):before {
      animation-delay: 800ms;
    }
    li:nth-child(5):before {
      animation-delay: 1000ms;
    }
  }
`

class Processing extends Component {
  render() {
    return (
      <StyledProcessing>
        <ul className="processing">
          <li></li>
          <li></li>
          <li></li>
          <li></li>
          <li></li>
        </ul>
        <h4 className="textHint">{this.props.label}</h4>
      </StyledProcessing>
    )
  }
}

export default Processing;



// WEBPACK FOOTER //
// ./src/components/instore/Processing.js